<template>
  <div id="my-account">
    <section class="bg-grey py-5 mt-5 mt-lg-0">
      <form @submit.stop.prevent="onSubmit">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <h4><b>ข้อมูลส่วนตัว</b></h4>
              <div>กรุณากรอกข้อมูลด้านล่างให้ครบถ้วน เพื่อการลงทะเบียนอย่างสมบูรณ์และเพื่อประโยชน์กับการรับข้อมูล
                หรือติดต่อกับเอเจนท์อย่างสมบูรณ์</div>
            </div>
            <div class="col-12">
              <div class="bg-white position-relative w-100 mt-3 mt-lg-5 p-4">
                <div class="col-12">
                  <div class="row">
                    <div class="col-12 col-sm-4 col-lg-4 pb-3">
                      <img :src="previewImage" class="w-100 mb-2">
                      <b-form-file accept="image/*" v-model="file" @change="onFileChange($event)"></b-form-file>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-lg-4 border-bottom-mobile">
                      <div class="mb-4">
                        <label>ชื่อ-นามสกุล</label>
                        <div class="row">
                          <div class="col">
                            <b-form-input id="fName" name="fName" v-model="form.fName" v-validate="{ required: true }"
                              :state="validateState('fName')" class="bold">
                            </b-form-input>
                          </div>
                          <div class="col">
                            <b-form-input id="lName" name="lName" v-model="form.lName" v-validate="{ required: true }"
                              :state="validateState('lName')" class="bold">
                            </b-form-input>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-lg-4 border-bottom-mobile">
                      <div class="mb-4 mt-4 mt-lg-0">
                        <label>อีเมล</label>
                        <div class="text-grey pt-2">{{form.email}}</div>
                      </div>
                    </div>
                    <div class="col-12 col-lg-4 border-bottom-mobile">
                      <div class="mb-4 mt-4 mt-lg-0">
                        <label>เบอร์โทรศัพท์ I <u class="text-blue"><b>เปลี่ยน</b></u></label>
                        <div class="row">
                          <div class="col-3 text-grey pt-2">
                            +660
                          </div>
                          <div class="col-9">
                            <b-form-input id="mobile" name="mobile" v-model="form.mobile"
                              v-validate="{ required: true }" :state="validateState('mobile')" class="bold">
                            </b-form-input>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-lg-4 border-bottom-mobile">
                      <div class="mb-4 mt-4 mt-lg-0">
                        <label>เดือน / วัน / ปี เกิด</label>
                        <div class="row">
                          <div class="col-6 col-lg pr-lg-1 mb-3 mb-lg-0">
                            <b-form-select v-model="month">
                              <b-form-select-option :value="item.value" v-for="(item, i) in optionMonth"
                                :key="`year${i}`">{{item.name}}</b-form-select-option>
                            </b-form-select>
                          </div>
                          <div class="col-6 col-lg px-lg-1 mb-3 mb-lg-0">
                            <b-form-select v-model="day">
                              <b-form-select-option :value="item.value" v-for="(item, i) in optionDay"
                                :key="`year${i}`">{{item.name}}</b-form-select-option>
                            </b-form-select>
                          </div>
                          <div class="col-12 col-lg pl-lg-1">
                            <b-form-select v-model="year">
                              <b-form-select-option :value="item.value" v-for="(item, i) in optionYear"
                                :key="`year${i}`">{{item.name}}</b-form-select-option>
                            </b-form-select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-lg-4 border-bottom-mobile">
                      <div class="mb-4 mt-4 mt-lg-0">
                        <b-form-group label="*กรุณาเลือก">
                          <b-form-radio-group id="type" v-model="form.type" name="type" v-validate="{ required: true }"
                            :state="validateState('type')">
                            <b-form-radio value="A" class="pl-0">เอเจนท์ สังกัดบริษัทฯ</b-form-radio>
                            <b-form-radio value="f">ฟรีแลนซ์</b-form-radio>
                          </b-form-radio-group>
                        </b-form-group>
                      </div>
                    </div>
                    <div class="col-12 col-lg-4">
                      <div class="mb-4 mt-4 mt-lg-0">
                        <label>ชื่อบริษัท</label>
                        <b-form-input id="company" name="company" v-model="form.company" v-validate="{ required: true }"
                          :state="validateState('company')">
                        </b-form-input>
                      </div>
                    </div>
                    <div class="col-12 col-lg-4">
                      <label>สนใจโครงการ</label>
                      <div class="field-search">
                        <div class="float-left">เลือกโครงการ</div>
                        <div class="float-right">
                          <div class="d-inline">
                            <i class="fas fa-caret-down"></i>
                          </div>
                        </div>
                        <div class="block-dropdown">
                          <div class="field-search-dropdown">
                            <label class="container-checkbox" v-for="(item, i) in projectList"
                              :key="`project${i}`">{{item.projectName_TH}}
                              <input type="checkbox" v-model="item.checked">
                              <span class="checkmark"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 mt-3 mt-lg-5 pt-3 mb-4">
                      <div class="border-bottom"></div>
                    </div>
                    <div class="col-12 mb-4">
                      <b>ที่อยู่ในการจัดส่งเอกสาร</b>
                    </div>
                    <div class="col-12 col-lg-4">
                      <div class="mb-4">
                        <b-form-input placeholder="เลขที่ / ชั้น" v-model="form.address"></b-form-input>
                      </div>
                    </div>
                    <div class="col-12 col-lg-4">
                      <div class="mb-4">
                        <b-form-input placeholder="หมู่บ้าน" v-model="form.village"></b-form-input>
                      </div>
                    </div>
                    <div class="col-12 col-lg-4">
                      <div class="mb-4">
                        <b-form-input placeholder="ซอย" v-model="form.soi"></b-form-input>
                      </div>
                    </div>
                    <div class="col-12 col-lg-4">
                      <div class="mb-4">
                        <b-form-input placeholder="ถนน" v-model="form.road"></b-form-input>
                      </div>
                    </div>
                    <div class="col-12 col-lg-4 mb-4">
                      <b-form-select v-model="districts" @change="getSubDistricts($event)">
                        <b-form-select-option value="">กรุณาเลือกเขต / อำเภอ</b-form-select-option>
                        <b-form-select-option :value="item.id" v-for="(item, i) in districtsList" :key="i">
                          {{item.name_in_thai}}</b-form-select-option>
                      </b-form-select>
                    </div>
                    <div class="col-12 col-lg-4 mb-4">
                      <b-form-select v-model="subdistricts">
                        <b-form-select-option value="">กรุณาเลือกแขวง / ตำบล</b-form-select-option>
                        <b-form-select-option :value="item.id" v-for="(item, i) in subdistrictsList" :key="i">
                          {{item.name_in_thai}}</b-form-select-option>
                      </b-form-select>
                    </div>
                    <div class="col-12 col-lg-4 mb-4">
                      <b-form-select v-model="provinces" @change="getDistricts($event)">
                        <b-form-select-option value="">กรุณาเลือกจังหวัด</b-form-select-option>
                        <b-form-select-option :value="item.id" v-for="(item, i) in provincesList" :key="i">
                          {{item.name_in_thai}}</b-form-select-option>
                      </b-form-select>
                    </div>
                    <div class="col-12 col-lg-4 mb-4">
                      <b-form-input placeholder="รหัสไปรษณีย์" v-model="form.zipcode"></b-form-input>
                    </div>
                    <div class="col-12 pt-3 mb-4">
                      <div class="border-bottom"></div>
                    </div>
                    <div class="col-12 text-center pb-4">
                      <button class="bold btn btn-primary" type="submit">แก้ไขข้อมูล</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </section>
    <section>
      <b-modal id="modal-save" centered>
        <template v-slot:modal-header="{ close }">
          <h2 class="text-right w-100 mb-0">
            <img src="./../../assets/images/icon/close.png" width="25" class="cursor-pointer" @click="close()">
          </h2>
        </template>
        <template v-slot:default>
          <div class="text-center" v-html="msgSave"></div>
        </template>
      </b-modal>
    </section>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        file: null,
        previewImage: null,
        form: {
          fName: '',
          lName: '',
          email: '',
          mobile: '',
          type: '',
          company: '',
          zipcode: '',
          address: '',
          village: '',
          soi: '',
          road: '',
          project_list: '',
          password: ''
        },
        msgSave: '',
        year: '',
        optionYear: [{
          value: '',
          name: 'ปี (ค.ศ.)'
        }],
        month: '',
        optionMonth: [{
          value: '',
          name: 'เดือน'
        }],
        day: '',
        optionDay: [{
          value: '',
          name: 'วัน'
        }],
        projectList: [],
        provinces: '',
        districts: '',
        subdistricts: '',
        provincesList: '',
        districtsList: '',
        subdistrictsList: '',
        getLocal: JSON.parse(localStorage.getItem('agenthub-info'))
      }
    },
    methods: {
      getUserInfo() {
        const header = {
          'headers': {
            'token': this.getLocal.token
          }
        }
        const email = this.getLocal.email
        const formData = new FormData
        formData.append('firstName', '')
        formData.append('lastName', '')
        formData.append('email', email)
        formData.append('mobile', this.form.mobile)
        formData.append('company', '')
        formData.append('pageNo', 1)
        formData.append('pageSize', 12)
        formData.append('sortOrder', 'UpdateDate DESC')
        this.$http.post(this.$app.baseURL + this.$path.userSearch, formData, header).then(
          res => {
            const data = res.data.data[0]
            this.form = {
              email: data.email,
              fName: data.firstName,
              lName: data.lastName,
              mobile: data.mobile,
              type: data.agentType,
              company: data.company,
              zipcode: data.zipCode ? data.zipCode : '',
              address: data.address ? data.address : '',
              village: data.village ? data.village : '',
              soi: data.soi ? data.soi : '',
              road: data.road ? data.road : '',
              project_list: '',
              password: ''
            }
            this.getDistricts(data.provinceID)
            this.getSubDistricts(data.districtID)
            this.provinces = data.provinceID ? data.provinceID : ''
            this.districts = data.districtID ? data.districtID : ''
            this.subdistricts = data.subDistrictID ? data.subDistrictID : ''
            this.previewImage = data.profileImage
            localStorage.setItem('agenthub-info', JSON.stringify(data))
          })
      },
      validateState(ref) {
        if (this.$veeFields[ref] && (this.$veeFields[ref].dirty || this.$veeFields[ref].validated)) {
          return !this.$veeErrors.has(ref);
        }
        return null;
      },
      onSubmit() {
        const header = {
          'headers': {
            'token': this.getLocal.token
          }
        }
        this.$validator.validateAll().then(result => {
          if (!result) {
            return;
          }
          let loading = this.$loading.show()
          const formData = new FormData
          formData.append('fName', this.form.fName)
          formData.append('lName', this.form.lName)
          formData.append('email', this.form.email)
          formData.append('mobile', this.form.mobile)
          formData.append('type', this.form.type)
          formData.append('company', this.form.company)
          formData.append('choice', this.filterProject())
          formData.append('address', this.form.address)
          formData.append('village', this.form.village)
          formData.append('soi', this.form.soi)
          formData.append('road', this.form.road)
          formData.append('subdistricts', this.subdistricts)
          formData.append('diststricts', this.districts)
          formData.append('province', this.provinces)
          formData.append('profile_image', this.file)
          formData.append('project_list', this.filterProject())
          formData.append('password', this.form.password)
          formData.append('zipcode', this.form.zipcode)
          this.$http.post(this.$app.baseURL + this.$path.userUpdate, formData, header).then(
            res => {
              loading.hide()
              this.$bvModal.show('modal-save')
              if (res.data.status == 200) {
                this.getUserInfo()
                this.msgSave = '<h4><b>บันทึกเสร็จสิ้น</b></h4><div class="py-4">แก้ไขข้อมูลเสร็จสิ้น</div>'
              } else {
                this.msgSave = '<h4><b>คุณไม่สามารถบันทึกได้</b></h4>'
              }
            }, () => {
              loading.hide()
              this.$bvModal.show('modal-save')
              this.msgSave = '<h4><b>คุณไม่สามารถบันทึกได้</b></h4>'
            }
          )
        });
      },
      resetForm() {
        this.form = {
          fName: '',
          lName: '',
          email: '',
          mobile: '',
          type: '',
          company: '',
          zipcode: '',
          address: '',
          village: '',
          soi: '',
          road: '',
          project_list: '',
          password: ''
        }
        this.provinces = ''
        this.districts = ''
        this.subdistricts = ''
        this.$nextTick(() => {
          this.$validator.reset();
        })
      },
      getFilterProjectName() {
        this.$http.get(this.$app.baseURL + this.$path.getFilterProjectName).then(res => {
          for (const item of res.data.data) {
            item.checked = false;
          }
          this.projectList = res.data.data
        })
      },
      filterProject() {
        let filterProject = []
        for (const item of this.projectList) {
          if (item.checked) {
            filterProject.push(item.project_Code)
          }
        }
        filterProject = filterProject.join(',')
        return filterProject
      },
      getFilterAddress() {
        this.$http.post(this.$app.baseURL + this.$path.provinces, '').then(res => {
          this.provincesList = res.data.data
        })
      },
      getDistricts(value) {
        const formData = new FormData
        formData.append('province_id', value)
        this.$http.post(this.$app.baseURL + this.$path.districts, formData).then(res => {
          this.districtsList = res.data.data
        })
      },
      getSubDistricts(value) {
        const formData = new FormData
        formData.append('district_id', value)
        this.$http.post(this.$app.baseURL + this.$path.subdistricts, formData).then(res => {
          this.subdistrictsList = res.data.data
        })
      },
      onFileChange(e) {
        this.file = e.target.files[0];
        this.previewImage = this.file ? URL.createObjectURL(this.file) : null;
      }
    },
    mounted() {
      this.getUserInfo()
      this.getFilterProjectName()
      this.getFilterAddress()
    }
  }
</script>

<style scoped>
  .field-search {
    border-width: 1px;
  }

  .field-search {
    padding: 8px 7px;
  }

  .field-search i {
    background: #fff;
    border-radius: 0;
    color: #000;
    padding: 0;
  }

  .block-dropdown {
    padding-top: 45px;
  }

  .field-search-dropdown {
    width: 100%;
    border-color: #b7b7b7;
    box-shadow: none;
    max-height: 250px;
    overflow-y: auto;
  }

  .field-search:hover i {
    background: none;
  }
</style>